import { useQuery } from 'react-query';
import { QueryKeys } from '../QueryKey';
import axiosInstance from '../axiosConfig';

export function useGetProfessionalReviewRequests(id: string) {
    const getProfessionalReviewRequests = async (id: string) => {
        const response = await axiosInstance.get(
            `/api/professional-reviews-requests/${id}/sent`
        );
        const data = await response.data;
        return data;
    };
    return useQuery(QueryKeys.ProfessionalReviewRequests, () =>
        getProfessionalReviewRequests(id)
    );
}
